
export const lst_tipo_empresa = [
    { id: 1, nombre: "Grifo", value: 1 },
    { id: 2, nombre: "Reparación SM", value: 2 },
/*     { id: 3, nombre: "Sector Salud", value: 3 },
 */    { id: 4, nombre: "Obra DS", value: 4 },
    { id: 5, nombre: "Taller Mecanico", value: 5 },
]


